import {
    Route,
    Routes,
} from 'react-router-dom';
import {RequirePermission} from '../../utils/RequirePermission.tsx';

import {IndexPage} from './pages/IndexPage';
import {DetailPage} from './pages/DetailPage.tsx';
import {rbacActions} from '../../config/rbac/actions.ts';

// FNP-904. Index + detail only — there is deliberately no add or edit route.
// A defect signature is PRODUCED by the triage sweep from observed evidence; a
// human authoring one would mint a fingerprint that matches nothing. The only
// human write is triage (status/jiraKey), which happens on the detail page and
// is gated on UpdateDefectSignature.
export const DefectSignaturesLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action={rbacActions.ListDefectSignatures}>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':id'
                element={
                    <RequirePermission action={rbacActions.GetDefectSignature}>
                        <DetailPage/>
                    </RequirePermission>
                }
            />
        </Routes>
    );
};
